<template>
  <div class="container-top" :class="{ 'container-wide': lgAndUp || xlAndUp }">
    <div class="container-fluid">
      <div class="d-flex flex-column flex-sm-row my-3 justify-content-between">
        <div class="text-head font-weight-bold h2 text-dak">Follow up</div>

        <div class="">
          <router-link to="/">
            <el-button
              round
              size="large"
              class="secondary-button"
              @click="logout"
              >Logout</el-button
            >
          </router-link>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-12">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <a
                class="nav-link active"
                id="home-tab"
                data-toggle="tab"
                href="#home"
                role="tab"
                aria-controls="home"
                aria-selected="true"
                >Dashboard</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link"
                id="contact-tab"
                data-toggle="tab"
                href="#contact"
                role="tab"
                aria-controls="contact"
                aria-selected="true"
                >People</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link"
                id="profile-tab"
                data-toggle="tab"
                href="#profile"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
                >Task</a
              >
            </li>
          </ul>
        </div>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <FollowUpDashboard />
          </div>
          <div
            class="tab-pane fade"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <FollowUpTask :tasks="tasks" />
          </div>
          <div
            class="tab-pane fade"
            id="contact"
            role="tabpanel"
            aria-labelledby="contact-tab"
          >
            <PeopleToFollowUp :contacts="contacts" :loading="loading" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import PeopleToFollowUp from "./PeopleToFollowUp.vue";
import FollowUpTask from "./FollowUpTask.vue";
import axios from "@/gateway/backendapi";
import FollowUpDashboard from "./FollowUpDashboard.vue";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
export default {
  components: {
    PeopleToFollowUp: PeopleToFollowUp,
    FollowUpTask,
    FollowUpDashboard,
  },
  setup() {
    const contacts = ref([]);
    const tasks = ref([]);
    const personId = ref(localStorage.getItem("personId"));
    const { lgAndUp, xlAndUp, mdAndUp, xsOnly } = deviceBreakpoint();
    const statuses = ref([
      { name: "Pending", value: 0 },
      { name: "InProgress", value: 1 },
      { name: "Completed", value: 2 },
      { name: "Cancelled", value: 3 },
      { name: "Rescheduled", value: 4 },
      { name: "Stalled", value: 5 },
    ]);
    const loading = ref(false);

    // const getFollowUpContactDetails = async () => {
    //   loading.value = true;
    //   try {
    //     const { data } = await axios.get(
    //       "/api/FirsttimerManager/contactstofollow"
    //     );
    //     console.log(data);
    //     contacts.value = data.people;
    //     tasks.value = data.tasks.map((i) => {
    //       i.selectedStatus = statuses.value.find((j) => j.value == i.status);
    //       return i;
    //     });
    //     loading.value = false;
    //   } catch (err) {
    //     console.log(err);
    //     loading.value = false;
    //   }
    // };
    // getFollowUpContactDetails();

    const getFollowUpContactData = async () => {
      loading.value = true;
      if (personId.value) {
        try {
          const { data } = await axios.get(
            `/api/FirsttimerManager/contactstofollow/${personId.value}`
          );
          contacts.value = data.people;
          tasks.value = data.tasks.map((task) => {
            return {
              ...task,
              selectedStatus: statuses.value.find(
                (s) => s.value === task.status
              ),
            };
          });
          loading.value = false;
        } catch (err) {
          console.log(err);
          loading.value = false;
        }
      } else {
        try {
          const { data } = await axios.get(
            "/api/FirsttimerManager/contactstofollow"
          );
          contacts.value = data.people;
          tasks.value = data.tasks.map((task) => {
            return {
              ...task,
              selectedStatus: statuses.value.find(
                (s) => s.value === task.status
              ),
            };
          });
          loading.value = false;
        } catch (err) {
          console.log(err);
          loading.value = false;
        }
      }
    };
    getFollowUpContactData();

    const logout = () => {
      localStorage.removeItem("token");
    };
    return {
      personId,
      contacts,
      tasks,
      logout,
      statuses,
      loading,
      lgAndUp,
      xlAndUp,
      mdAndUp,
      xsOnly,
    };
  },
};
</script>

<style scoped></style>
